/* ==========================================================================
   SABR — chrome behaviour
   The markup now comes from snippets/chrome.liquid; this file keeps only the
   behaviour that survived the port: menu overlay, bag count, preloader,
   scroll reveal. Translation and the lang toggle are Shopify's job now.
   ========================================================================== */

(function () {
  'use strict';

  /* --- menu ---------------------------------------------------------------- */

  function wireMenu() {
    var menu = document.querySelector('[data-menu]');
    var opener = document.querySelector('[data-menu-open]');
    if (!menu || !opener) return;

    function open() {
      menu.setAttribute('data-open', '');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = menu.querySelector('a');
      if (first) first.focus();
    }
    function close() {
      menu.removeAttribute('data-open');
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      opener.focus();
    }

    opener.addEventListener('click', open);
    var closer = menu.querySelector('[data-menu-close]');
    if (closer) closer.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasAttribute('data-open')) close();
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') document.body.style.overflow = '';
    });
  }

  /* --- bag count ------------------------------------------------------------
     Rendered server-side on load; sabr:cartchange repaints it after an AJAX
     add so the count never lags behind the bag.                              */

  function paintBag(count) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) {
      el.textContent = count;
    });
    var bag = document.querySelector('[data-bag]');
    if (!bag) return;
    bag.setAttribute('data-bump', '');
    setTimeout(function () { bag.removeAttribute('data-bump'); }, 420);
  }

  document.addEventListener('sabr:cartchange', function (e) {
    paintBag(e.detail && typeof e.detail.count === 'number' ? e.detail.count : 0);
  });

  /* --- toast ---------------------------------------------------------------- */

  window.sabrToast = function (msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.setAttribute('data-show', '');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.removeAttribute('data-show'); }, 2200);
  };

  /* --- preloader ------------------------------------------------------------ */

  function wirePreloader() {
    var pre = document.querySelector('.preloader');
    if (!pre) return;
    function done() { pre.setAttribute('data-done', ''); }
    if (document.readyState === 'complete') setTimeout(done, 260);
    else window.addEventListener('load', function () { setTimeout(done, 260); });
    setTimeout(done, 3000);
  }

  /* --- scroll reveal -------------------------------------------------------- */

  function wireReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i, 8) * 40 + 'ms';
      io.observe(el);
    });
  }

  function init() {
    wireMenu();
    wirePreloader();
    wireReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
